import type { RefObject } from 'react'

import createFormJson from '../../demo/fixtures/create-form.json'
import type { Audience, AudienceType } from '../../demo/types'
import { ChipSelectable, Icon, PickButton } from '../../ui'
import styles from './CreatePage.module.css'

interface AudiencePickerProps {
  value: Audience
  onChange: (value: Audience) => void
  sectionRef?: RefObject<HTMLElement | null>
}

function toggleValue(values: string[], value: string): string[] {
  return values.includes(value) ? values.filter((item) => item !== value) : [...values, value]
}

export function AudiencePicker({ value, onChange, sectionRef }: AudiencePickerProps) {
  const setType = (type: AudienceType) => onChange({ ...value, type })
  return (
    <section ref={sectionRef} className={styles.field} data-scope="create-audience-picker">
      <div className={styles.labelRow}><span className={styles.label}>受众</span></div>
      <div className={styles.pickRow}>
        {createFormJson.audiences.map((item) => {
          const key = item.key as AudienceType
          return <PickButton key={key} selected={value.type === key} icon={<Icon name={item.icon as 'user' | 'user-cog'} size={18} />} onClick={() => setType(key)}>{item.label}</PickButton>
        })}
      </div>
      <div className={`${styles.customAudience} ${value.type === 'custom' ? styles.customAudienceOpen : ''}`} aria-hidden={value.type !== 'custom'} inert={value.type !== 'custom'}>
        <div className={styles.customInner}>
          <div className={styles.customGroup}>
            <b>年龄段</b>
            <div className={styles.chips}>{createFormJson.customAudience.ageBands.map((item) => <ChipSelectable key={item.key} selected={value.ageBands.includes(item.key)} onClick={() => onChange({ ...value, ageBands: toggleValue(value.ageBands, item.key) })}>{item.label}</ChipSelectable>)}</div>
          </div>
          <div className={styles.customGroup}>
            <b>性别</b>
            <div className={styles.chips}>{createFormJson.customAudience.genders.map((item) => <ChipSelectable key={item.key} selected={value.gender === item.key} onClick={() => onChange({ ...value, gender: item.key })}>{item.label}</ChipSelectable>)}</div>
          </div>
          <div className={styles.customGroup}>
            <b>兴趣标签</b>
            <div className={styles.chips}>{createFormJson.customAudience.interests.map((item) => <ChipSelectable key={item.key} selected={value.interests.includes(item.key)} onClick={() => onChange({ ...value, interests: toggleValue(value.interests, item.key) })}>{item.label}</ChipSelectable>)}</div>
          </div>
        </div>
      </div>
    </section>
  )
}
